var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 247,
    viewBox: "0 0 201 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.842 192.381L0 111.493V79.4902L198.142 192.483L104.175 247L0 187.593V154.939L18.5093 165.495L18.5091 165.525L104.051 214.306L141.842 192.381Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9469 54.5211L200.467 135.176V167.122L2.71289 54.4199L96.5686 0L200.467 59.2125V91.8077L182.167 81.3783L182.168 81.3475L96.6938 32.6352L58.9469 54.5211Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecondary);
export default __webpack_public_path__ + "static/media/logo-secondary.8c6d0c9cb465c0b1332fbb376c347b56.svg";
export { ForwardRef as ReactComponent };